import { render, staticRenderFns } from "./InvoicesTabs.vue?vue&type=template&id=78ed8a61&"
import script from "./InvoicesTabs.vue?vue&type=script&lang=js&"
export * from "./InvoicesTabs.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesTabs.vue?vue&type=style&index=0&id=78ed8a61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports